import { CartModel } from "atoms/models";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { formatZipCode } from "utils";
import Logo from "images/comporium-logo.png";

interface CancelData {
  cancellationDate: Date | null;
  cancellationReason: string;
  cancellationComments: string;
  securityFormAcknowledged: boolean;
  securityData: boolean;
}

const SecurityCancelForm: React.FC<{ cart: CartModel; cancelData: CancelData; setCancelData: Function }> = ({ cart, cancelData, setCancelData }) => {
  const [securityCancelModal, setSecurityCancelModal] = useState(false);
  return (
    <div className="cancel-security-form">
      <h4>View Security Acknowledgement</h4>
      <button
        className={cancelData.securityFormAcknowledged ? "btn btn-lg btn-success" : "btn btn-lg btn-primary"}
        onClick={() => setSecurityCancelModal(true)}
        disabled={!cancelData.cancellationDate}
      >
        Security Cancellation Form <i className={cancelData.securityFormAcknowledged ? "fa-solid fa-check" : "fa-solid fa-circle-exclamation"}></i>
      </button>
      <Modal show={securityCancelModal} onHide={() => setSecurityCancelModal(false)} className="cancel-security-form-modal">
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">
            <img src={Logo} className="w-100" alt="Comporium" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="fw-bold">NOTICE TO DISCONNECT SERVICE</h4>
          <p>
            This is official notification to disconnect my security system from your monitoring station. I also will allow your personnel access to
            the system to disconnect it from the telephone service if need be. I also understand that once this is completed, I will only have my
            local operating service and Comporium will NOT call local authorities or call list for any alarms.
          </p>
          <ul>
            <li className="list-unstyled">
              <strong>Customer Name:&nbsp;</strong>
              {cart.customerNameFirst} {cart.customerNameLast}
            </li>
            <li className="list-unstyled">
              <strong>Street Address:&nbsp;</strong>
              {cart.serviceStreetNumber}&nbsp;
              {cart.serviceStreetName}
            </li>
            <li className="list-unstyled">
              <strong>City, State, Zip:&nbsp;</strong>
              {cart.serviceCity}&nbsp;
              {cart.serviceState},&nbsp;
              {cart.serviceZipCode ? formatZipCode(cart.billingZipCode) : cart.billingZipCode}
            </li>
            <li className="list-unstyled">
              <strong>Account #:&nbsp;</strong>
              {cart.billId}
            </li>
          </ul>
          <p>Any credit on your bill will be mailed to you. If we can be of any assistance to you in the future, please contact us.</p>
          <div
            className={
              cancelData.securityFormAcknowledged
                ? "form-check form-check-reverse text-start text-success"
                : "form-check form-check-reverse text-start text-danger"
            }
          >
            <input
              className="form-check-input"
              type="checkbox"
              checked={cancelData.securityFormAcknowledged}
              onChange={() => {
                setCancelData({ ...cancelData, securityFormAcknowledged: !cancelData.securityFormAcknowledged });
              }}
              id="checkDefault"
              style={{ marginRight: "15px" }}
            />
            <label className="form-check-label" htmlFor="checkDefault">
              <strong>I acknowledge:</strong>
            </label>
          </div>
          <div>
            <strong>Date Effective:</strong>&nbsp;
            {cancelData?.cancellationDate
              ? `${String(cancelData.cancellationDate.getMonth() + 1).padStart(2, "0")}/` +
                `${String(cancelData.cancellationDate.getDate()).padStart(2, "0")}/` +
                `${cancelData.cancellationDate.getFullYear()}`
              : ""}
          </div>

          <p className="mt-4">
            <small className="fw-bold">
              **Installment Billing: If you are on a 24 Month Installment Plan, the remainder will be billed ALL at once.
            </small>
          </p>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SecurityCancelForm;
